"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import ruleFormatter from "../formatters/rules";
export default {
  enabledRules: function(holder) {
    return _.reject(holder.failure_messages, _.partial(this.ruleIsIgnored, holder));
  },
  ruleIsIgnored: function(holder, rule) {
    return _.find(
      holder.ignored_rules,
      function(ignored) {
        const ruleCopy = __spreadValues({}, rule);
        const ignoredRuleCopy = __spreadValues({}, ignored);
        ignoredRuleCopy.display_text = null;
        ruleCopy.display_text = null;
        return _.isEqual(ruleCopy, ignoredRuleCopy);
      }
    );
  },
  isApprovable: function(invoice) {
    return this.enabledRules(invoice).length === 0 && !this.isAbandoned(invoice) && _.all(_.pluck((invoice || {}).exception_events, "resolved_at"));
  },
  isAbandoned: function(invoice) {
    return invoice && invoice.state === "abandoned";
  },
  isMovedToTmsQueue: function(invoice) {
    return invoice && invoice.is_moved_to_tms_queue;
  },
  exceptionSummary: function(holder) {
    const exceptions = _.pluck(holder.exception_events, "message_override");
    const rules = _.map(this.enabledRules(holder), (r) => ruleFormatter.ruleAsPlainText(r));
    const both = exceptions.concat(rules);
    const first = _.first(both);
    const extra = both.length > 1 ? " and " + (both.length - 1) + " more" : "";
    return _.str.rtrim(first, ".") + extra;
  },
  allExceptionMessages: function(carrierInvoice, loadState, shouldIncludeInternalRules, prePependText, shouldIncludeDisplayTextDetails) {
    const rules = this.enabledRules(carrierInvoice);
    let visibleRules;
    if (shouldIncludeInternalRules) {
      visibleRules = rules;
    } else {
      visibleRules = _.reject(rules, _.property("internal_failure"));
    }
    const ruleMessages = _.map(visibleRules, function(rule) {
      return ruleFormatter.ruleAsPlainText(rule, prePependText, shouldIncludeDisplayTextDetails);
    });
    const loadStateExceptionEvents = loadState.exception_events || [];
    const carrierInvoiceExceptionEvents = carrierInvoice.exception_events || [];
    const exceptionEvents = loadStateExceptionEvents.concat(carrierInvoiceExceptionEvents);
    const exceptionMessages = _.map(exceptionEvents, function(e) {
      return e.message_override;
    });
    const allMessages = exceptionMessages.concat(ruleMessages);
    return allMessages.map((message) => {
      return prePependText + message;
    });
  }
};
